import { useSelector } from "react-redux";
import { Navigate } from "react-router";

export default function RestrictedRoute({  children }) {
    const authState= useSelector((state)=>state?.auth)
  return authState?.subStatus?.package_name ? <Navigate to="/pages/error/error-page5" replace /> : children;
}
